import { UNDO_REDO_SET_STATE, CARD_OPTIONS_UNDO_SUCCESS, CARD_OPTIONS_REDO_SUCCESS } from "../actions/types";

const initialState = {};

const undoRedoReducer = (state = initialState, action) => {
	// console.log('undoRedoReducer action.type = ',action.type);
	switch (action.type) {
        case UNDO_REDO_SET_STATE:
            return action.payload
		case CARD_OPTIONS_UNDO_SUCCESS:
			return action.payload
		case CARD_OPTIONS_REDO_SUCCESS:
			return action.payload
		default:
			return state;
	}
};

export default undoRedoReducer;
